/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, useMediaQuery } from "@mui/material"
import { useCallback, useEffect, useMemo, useState } from "react"
import { CardsList } from "./containers/Card"
import { ModalFaturamento } from "./containers/ModalFaturamento"
import { FATURAMENTO_TIPOS, FaturamentoType, IFaturamentoTipos, Projeto } from "src/components/projetos/types"
import { Formater, TypeRecords } from "src/framework/commons/Formater"
import { CalcularType } from "../.."
import { setPersonalizadoTabDoneStatus, setServicoInformationModalStatus } from "src/store/vendas/projetos/actions"
import { HspProvider } from "src/providers/cadastros/HspProvider"
import { Layout } from "../../layouts"
import { ResumoProjeto, ResumoProjetoRow } from "src/components/projetos/containers/ResumoProjeto"
import { OpcaoServicoSuspensa } from "src/components/projetos/containers/OpcaoServicoSuspensa"
import { NOVO_PROJETO_ENGENHARIA, POTENCIA_MINIMA_VERTICAL, PROPOSTA_OPTIONS } from "src/components/projetos/constants"
import theme from "src/theme/light"
import { InputsSection } from "src/components/projetos/containers/InputsSection"
import { Info } from "@mui/icons-material"
import { checarParametroRegiaoPotencia } from "src/components/projetos/utils/checarParametroRegiaoPotencia"
import { redirecionarParaEngenharia } from "src/components/projetos/utils/redirecionarParaEngenharia"
import { useHistory } from "react-router-dom"
import { validacaoValorServicoMinimo } from "src/components/projetos/utils/validarValorServicoMinimo"
import { PermissionUtil } from "src/framework/commons/PermissionUtil"
import { ProjetosProvider } from "src/providers/ProjetosProvider"
import { verificaPendenciaTrocaComponente } from "src/components/projetos/utils/verificaPendenciaTrocaComponente"
import { showPendenciaTrocaComponenteAlert } from "src/components/projetos/utils/showPendenciaTrocaComponenteAlert"
import adminStore from "src/store/AdminStore"
import { mostrarAvisoServicoRemovido } from "src/components/projetos/utils/mostrarAvisoServicoRemovido"
import { notifierStore } from "src/framework/store/NotifierStore"
import { alterandoServico$, calculoProjetoRealizado$, exibeJustificativaValorServico$, formState$ } from "src/store/vendas/projetos/store"
import { resetarProjeto } from "src/components/projetos/utils/resetarProjeto"
import { useObservable } from "src/framework/store/storeUtil"
import { useProjetoPersonalizadoHibridoStore } from "src/store/vendas/projetos/personalizado_hibrido/personalizadoHibrido.store"

interface FinalizacaoProps {
  onClickBack: () => void
  onClickNext: () => void
  calcular: (data?: CalcularType) => Promise<any>
}

const projetosProvider = new ProjetosProvider()
const hspProvider = new HspProvider()
let timerCalcular: NodeJS.Timeout

const Finalizacao = ({ onClickBack, onClickNext, calcular }: FinalizacaoProps) => {
  const projetoState = useProjetoPersonalizadoHibridoStore(store => store.state.data);
  const { changeValue } = useProjetoPersonalizadoHibridoStore(store => store.actions);
  const history = useHistory();
  const permissoes = PermissionUtil.getPermissions();
  
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [valorMinimoServico, setValorMinimoServico] = useState(0)
  const [modalFaturamento, setModalFaturamento] = useState({ status: false, imgUrl: '', title: '' })
  const [calculando, setCalculando] = useState(false)

  const calculoProjetoRealizado = useObservable(calculoProjetoRealizado$);
  const alterandoServico = useObservable(alterandoServico$);

  const [hspMedio, setHspMedio] = useState<number>(0)

  useEffect(()=>{
    if ((projetoState.isEdit || projetoState.clonar_projeto) && Number(projetoState.valor_servico || 0) > 0 && !projetoState?.revenda?.segmentos_servico?.includes("on")) {
      changeValue({
        valor_servico: 0,
        valor_servico_pis_cofins: 0,
        servico: null,
        codigo_servico: "",
        justificativa_valor_servico: null,
        tipo_proposta: PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null
      });
      
      mostrarAvisoServicoRemovido()
    }
  },[])

  const potenciaTotal = useMemo<number>(() => {
    const moduloSelecionado = projetoState.modulosList?.find(item => item.selecionado);
    const potencia = moduloSelecionado?.potencia || 0;
    const quantidade = moduloSelecionado?.quantidade || 1;
    return Number((potencia / 1000.0 * quantidade).toFixed(2));
  },[projetoState?.modulosList]);

  const potenciaVertical = useMemo<boolean>(() => {
    return potenciaTotal > POTENCIA_MINIMA_VERTICAL
  },[potenciaTotal]);

  useEffect(()=>{
    if (potenciaTotal > 0) {
      projetosProvider.calcularValorMinimoServico(potenciaTotal || 0).then((response) => {
        setValorMinimoServico(response.data?.valor_minimo_servico || 0)
      })
    }
  },[potenciaTotal])

  useEffect(()=>{
    if (servicoObrigatorio && (projetoState?.valor_servico || 0) > 0 && valorMinimoServico > 0 && !validacaoValorServicoMinimo(projetoState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      notifierStore.setNotifier({
        title: 'Atenção!',
        content: [
          'O valor do serviço não atende às exigências vigentes.',
          'Por favor, atualize conforme as instruções fornecidas abaixo do campo "Valor do Serviço Líquido”.'
        ],
        timeOut: 4000,
        onClose: () => notifierStore.setOpen(false),
      });
      notifierStore.setOpen(true);
    }
  },[valorMinimoServico, potenciaTotal])
  
  useEffect(() => {
    if (potenciaVertical && Number(projetoState?.valor_servico) > 0) {
      redirecionarParaEngenharia({
        onNegation: () => {
          formState$.next({
            ...resetarProjeto(projetoState), 
            ...NOVO_PROJETO_ENGENHARIA,
            servico: projetoState?.servico,
            valor_servico: projetoState?.valor_servico, 
            id: 0,
          })
          history.push('/projetos/verticais/novo',{ allowAccess: true })
        },
        onConfirmation: () => {
          changeValue({
            servico: null,
            valor_servico: 0,
            tempo_garantia_servico: 0
          })
        },
      });
    }
  },[potenciaVertical, history, projetoState?.valor_servico, changeValue])

  useEffect(() => {
    if (projetoState.latitude && projetoState.longitude) {
      hspProvider.calcular(projetoState.latitude, projetoState.longitude).then((hsp)=>{
        setHspMedio(hsp?.hsp_medio || 0)
      })
    }
  },[projetoState.latitude, projetoState.longitude])

  useEffect(()=>{
    clearTimeout(timerCalcular)
    setCalculando(true)
    timerCalcular = setTimeout(()=>{
      calcular()
      calcular().finally(() => setCalculando(false))
    }, 300)
  }, [calcular])

  useEffect(()=>{
    for (const idx in FATURAMENTO_TIPOS){
      FATURAMENTO_TIPOS[idx].disable = false;
    }
  }, [projetoState.isEdit]);

  const resumoProjeto = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Título', value: projetoState.titulo || '' },
      { label: 'HSP médio', value: hspMedio.toLocaleString() },
      { label: 'Potência do gerador (kWp)', value: `${(projetoState.resultado_calculos?.componentes?.potencia_gerador || 0).toLocaleString()} (kWp)` },
      { label: 'Peso do gerador (Kg)', value: `${(projetoState.resultado_calculos?.componentes?.peso_gerador || 0).toLocaleString()} (Kg)` },
      { label: 'Peso do gerador no telhado (Kg)', value: `${(projetoState.resultado_calculos?.componentes?.peso_telhado || 0).toLocaleString()} (Kg)` }
    ]
  }, [hspMedio, projetoState.titulo, projetoState.resultado_calculos])

  const valoresCalculos = useMemo((): { total: number; totalComponentes: number; totalServico: number } =>{
    const totalComponentes = Number(projetoState.resultado_calculos?.componentes?.valor || 0)
    const totalServico = Number(projetoState.resultado_calculos?.servicos?.valor_com_pis_cofins || 0)
    return { total: totalServico + totalComponentes, totalComponentes, totalServico }
  },[projetoState.resultado_calculos?.componentes?.valor, projetoState.resultado_calculos?.servicos?.valor_com_pis_cofins])
  
  const secaoValores = useMemo((): ResumoProjetoRow[] =>{
    return [
      { label: 'Valor dos produtos', value: Formater.toString(valoresCalculos.totalComponentes, TypeRecords.CURRENCY) },
      { label: (
        <Box display="flex" alignItems={isMobile ? "end" : "center"}>
          <Typography style={{ display: 'block', textAlign: 'start' }} variant='subtitle1'>Valor do serviço da revenda com PIS/COFINS</Typography>
          <Box onClick={() => setServicoInformationModalStatus(true)} component={'button'} style={{ background: 'none', cursor: 'pointer' }} border={"none"}>
            <Info color="primary" fontSize={"small"} />
          </Box>
        </Box>
      ),
        value: Formater.toString(valoresCalculos.totalServico, TypeRecords.CURRENCY),
        hide: Number(valoresCalculos.totalServico || 0) === 0,
      },
      { label: 'Valor total', value: <strong style={{ color: theme.palette.primary.main }}>{Formater.toString(valoresCalculos.total, TypeRecords.CURRENCY)}</strong> }
    ]
  },[valoresCalculos])

  const servicoObrigatorio = useMemo(()=>{
    if (potenciaVertical) return false;

    const moduloSelecionado = projetoState?.modulosList?.find(item => item.selecionado);
    if (!checarParametroRegiaoPotencia(moduloSelecionado)?.status) return false;

    return projetoState.tipo_faturamento === 'cliente' && projetoState.tipo_proposta?.value === 'gerador-com-instalacao'
  },[potenciaVertical, projetoState.tipo_faturamento, projetoState.tipo_proposta?.value, projetoState?.modulosList])

  const mostrarCampoValorServico = useMemo(()=>{
    return !!(servicoObrigatorio && projetoState.recebe_servico) 
  },[servicoObrigatorio, projetoState.recebe_servico])

  const exibirJustificativaValorServico = useMemo(() => {
    if (!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETOS_EDITAR_ESPECIAL_SERVICO, permissoes)) return false;
    if (!mostrarCampoValorServico) return false;

    const valorServicoProjeto = Number(projetoState?.valor_servico || 0)

    if (valorServicoProjeto === 0) return false;
    if (Number(valorMinimoServico || 0) === 0) return false;

    return valorServicoProjeto < valorMinimoServico;
  },[projetoState?.valor_servico, mostrarCampoValorServico, permissoes, valorMinimoServico])

  useEffect(()=>{
    exibeJustificativaValorServico$.next(exibirJustificativaValorServico)
  },[exibirJustificativaValorServico])

  const handleNext = useCallback(async () => {
    if (projetoState?.isEdit) {
      const dataProjeto: Projeto = {...projetoState};
      if (projetoState?.id) {
        await adminStore.getProjetoTrocasPendentes(projetoState?.id).then((resp) => {
          if (resp && resp?.componentes) dataProjeto.componentes = resp?.componentes;
          if (resp && resp?.componentes_modificados) dataProjeto.componentes_modificados = resp?.componentes_modificados;
        });
      }
      if (verificaPendenciaTrocaComponente(dataProjeto)) {
        showPendenciaTrocaComponenteAlert();
        return;
      }
    }

    onClickNext()
  },[onClickNext, projetoState?.isEdit])

  useEffect(()=>{
    if (projetoState.recebe_servico === false || !projetoState.revenda) {
      const opt = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao') || null
      changeValue({ tipo_proposta: opt })
    }
  },[projetoState.recebe_servico, projetoState.revenda])

  const [textoTooltipDisabled, setTextoTooltipDisabled] = useState<string>("Para salvar o projeto é necessário aceitar os termos do projeto.");
  const doneButtonIsDisabled = useMemo(()=>{
    if (!projetoState.tipo_proposta) {
      setTextoTooltipDisabled("Para salvar o projeto, é necessário preencher o tipo de proposta");
      return true;
    }
    if (servicoObrigatorio && !projetoState.valor_servico) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (servicoObrigatorio && projetoState.valor_servico && Number(projetoState.valor_servico) === 0) {
      setTextoTooltipDisabled("Para salvar o projeto é necessário preencher o valor do serviço.");
      return true;
    }
    if (servicoObrigatorio && (projetoState?.valor_servico || 0) > 0 && !validacaoValorServicoMinimo(projetoState?.valor_servico || 0, valorMinimoServico, permissoes)) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir o valor mínimo do serviço`);
      return true;
    }
    if (exibirJustificativaValorServico && !(projetoState?.justificativa_valor_servico || "")) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário inserir a justificativa do valor de serviço`);
      return true;
    }
    if (!calculoProjetoRealizado) {
      setTextoTooltipDisabled(`Para finalizar o projeto é necessário realizar o cálculo dos valores do projeto.`);
      return true;
    }
    if (alterandoServico || calculando) {
      setTextoTooltipDisabled(`Aguarde o calculo finalizar para prosseguir.`);
      return true;
    }

    return false
  },[exibirJustificativaValorServico, projetoState?.justificativa_valor_servico, valorMinimoServico, projetoState.tipo_proposta, projetoState.valor_servico, servicoObrigatorio, permissoes, calculoProjetoRealizado, alterandoServico, calculando])

  useEffect(()=>{
    setPersonalizadoTabDoneStatus('finalizacao', !doneButtonIsDisabled)
  },[doneButtonIsDisabled])

  return (
    <>
      <Layout
        nextButtonIsDisabled={doneButtonIsDisabled}
        nextButtonDisabledTooltip={textoTooltipDisabled}
        title="Faturamento"
        subtitle="Escolha o tipo de faturamento!"
        onClickBack={onClickBack}
        onClickNext={handleNext}
        nextButtonLabel='Finalizar projeto'
      >
        <Box p={2}>
          <CardsList
            selected={projetoState.tipo_faturamento}
            onSelect={(tipo) => {
              const valor = tipo as FaturamentoType;
              const _faturamentoTipo = FATURAMENTO_TIPOS.find((f: IFaturamentoTipos) => f.id === valor);

              if (!_faturamentoTipo?.disable) {
                const values: Partial<Projeto> = { tipo_faturamento: valor };

                if (valor !== 'cliente') {
                  const tipoProposta = PROPOSTA_OPTIONS.find(item => item.value === 'gerador-sem-instalacao');
                  values.tipo_proposta = tipoProposta || null;
                }

                if (Number(projetoState.valor_servico || 0) !== 0) {
                  values.valor_servico = 0;
                  values.tempo_garantia_servico = 0;
                  calcular({ valorServico: 0 });
                }

                changeValue(values);
              }
            }}
            handleClickOnMoreInformations={id => setModalFaturamento({status: true, imgUrl: FATURAMENTO_TIPOS.find(item => item.id === id)?.modal.imgUrl || '', title: FATURAMENTO_TIPOS.find(item => item.id === id)?.modal.title || '' })}
            items={FATURAMENTO_TIPOS.map(({ id, title, subtitle, disable }) => ({ id, title, subtitle, disable }))}
          />

          <Box marginBottom={2}>
            <InputsSection
              mostrarCampoValorServico={mostrarCampoValorServico}
              servicoObrigatorio={servicoObrigatorio}
              formState={projetoState}
              setFormState={changeValue}
              valorMinimoServico={(projetoState.valor_servico || 0) > 0 ? valorMinimoServico > 0 && validacaoValorServicoMinimo((projetoState.valor_servico || 0), valorMinimoServico, permissoes) ? 0 : valorMinimoServico : 0}
              exibirJustificativaValorServico={exibirJustificativaValorServico}
            />
          </Box>

          {!projetoState?.recebe_servico && (
            <Box marginBottom={2}>
              <OpcaoServicoSuspensa />
            </Box>
          )}

          <Box marginBottom={2}>
            <ResumoProjeto
              formState={projetoState}
              valores={secaoValores}
              resumoProjeto={resumoProjeto}
              simularFuncionamento={false}
            />
          </Box>
        </Box>
      </Layout>
      
      {modalFaturamento.status && <ModalFaturamento
        title={modalFaturamento.title}
        imgUrl={modalFaturamento.imgUrl}
        open={modalFaturamento.status}
        onClose={()=> setModalFaturamento({ status: false, imgUrl: '', title: '' })}
      />}
    </>
  )
}

export { Finalizacao }
